module.exports = __webpack_public_path__ + "img/mustach.e2afae78.png";